export enum PreferencePlaceEnum {
    EMPTY = '',
    AFRICA = 'africa',
    ASIA = 'asia',
    EUROPE = 'europe',
    MIDDLE_EAST = 'middle-east',
    NORTH_AMERICA = 'north-america',
    SOUTH_AMERICA = 'south-america',
    OCEANIA = 'oceania',
    WORLD = 'world',
}
